export default "__VITE_ASSET__3e9890ae__"